// extracted by mini-css-extract-plugin
export var chip = "_41-0";
export var filterDropdown = "_41-5";
export var filterItem = "_41-6";
export var icon = "_41-1";
export var removeButton = "_41-3";
export var removeIcon = "_41-4";
export var separator = "_41-2";